import InputMask from 'react-input-mask';

interface PassengerInfoSectionProps {
	address: {
		cep: string;
		uf: string;
		city: string;
		neighborhood: string;
		street: string;
		number: string;
		complement: string;
	};
	passengerPhone: string;
	onPassengerPhoneChange: (value: string) => void;
	phoneRequired?: boolean;
}

const PassengerInfoSection: React.FC<PassengerInfoSectionProps> = ({
	address,
	passengerPhone,
	onPassengerPhoneChange,
	phoneRequired = false,
}) => {
	const { cep, uf, city, neighborhood, street, number, complement } = address;
	return (
		<div>
			<h4 className="mb-3 text-base font-semibold text-primary">
				Informações do passageiro
			</h4>
			<div className="grid grid-cols-4 gap-4 mb-4">
				<div className="w-full">
					<div className="mb-1 text-[12px] text-[#505050] font-normal">CEP</div>
					<input
						type="text"
						value={cep}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div className="w-full">
					<div className="mb-1 text-[12px] text-[#505050] font-normal">UF</div>
					<input
						type="text"
						value={uf}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div className="w-full">
					<div className="mb-1 text-[12px] text-[#505050] font-normal">
						Cidade
					</div>
					<input
						type="text"
						value={city}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div className="w-full">
					<div className="mb-1 text-[12px] text-[#505050] font-normal">
						Bairro
					</div>
					<input
						type="text"
						value={neighborhood}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
			</div>
			<div className="grid grid-cols-4 gap-4">
				<div className="col-span-2 w-full">
					<div className="mb-1 text-[12px] text-[#505050] font-normal">Rua</div>
					<input
						type="text"
						value={street}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div className="col-span-1 w-full">
					<div className="grid grid-cols-2 gap-2">
						<div className="w-full">
							<div className="mb-1 text-[12px] text-[#505050] font-normal">
								Número
							</div>
							<input
								type="text"
								value={number}
								readOnly
								className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
							/>
						</div>
						<div className="w-full">
							<div className="mb-1 text-[12px] text-[#505050] font-normal">
								Complemento
							</div>
							<input
								type="text"
								value={complement}
								readOnly
								className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
							/>
						</div>
					</div>
				</div>
				<div className="w-full">
					<div className="mb-1 text-[12px] text-[#505050] font-normal">
						Telefone
						{phoneRequired && <span className="text-red">*</span>}
					</div>
					<InputMask
						mask="(99) 99999-9999"
						value={passengerPhone || ''}
						onChange={(e) => onPassengerPhoneChange(e.target.value)}
						className="w-full h-8 rounded-[4px] border border-gray-400 pl-2 text-xs text-gray-800"
					/>
				</div>
			</div>
		</div>
	);
};

export default PassengerInfoSection;
